{
  "byline": {
    "by": "بقلم {{authors}}",
    "coAuthored": "بمشاركة {{authors}}",
    "and": "و"
  },
  "meta": {
    "readTime_zero": "أقل من دقيقة",
    "readTime_one": "دقيقة واحدة للقراءة",
    "readTime_two": "دقيقتان للقراءة",
    "readTime_few": "{{count}} دقائق للقراءة",
    "readTime_many": "{{count}} دقيقة للقراءة",
    "readTime_other": "{{count}} دقيقة للقراءة",
    "published": "نُشر في {{date}}",
    "updated": "حُدث في {{date}}",
    "category": "التصنيف"
  },
  "donation": {
    "title": "ادعم الصحافة المستقلة",
    "description": "تساعد مساهمتك في استمرار تحقيقاتنا.",
    "cta": "تبرع الآن",
    "coffeeTitle": "ادعمنا بفنجان قهوة",
    "coffeeText": "طريقة بسيطة لدعم تقاريرنا: قدّم لنا فنجان قهوة عبر Buy Me a Coffee. كل فنجان يُحدث فرقاً.",
    "coffeeCta": "ادعمنا عبر Buy Me a Coffee"
  },
  "share": {
    "title": "شارك هذه القصة",
    "copyLink": "نسخ الرابط",
    "copied": "تم نسخ الرابط!",
    "twitter": "شارك على تويتر",
    "facebook": "شارك على فيسبوك"
  },
  "related": {
    "title": "قصص ذات صلة"
  },
  "translation": {
    "availableIn": "متوفر أيضاً بـ",
    "pending": "الترجمة قيد الانتظار"
  },
  "author": {
    "articlesHeader": "مقالات {{name}}",
    "noArticles": "لا توجد مقالات منشورة بعد.",
    "articlesCount": "مقالات",
    "avgReadTime": "متوسط"
  },
  "search": {
    "hint": "ابحث في جميع المقالات المنشورة بالفرنسية والإنجليزية والعربية.",
    "resultsCount_zero": "لا توجد نتائج لـ \"{{query}}\"",
    "resultsCount_one": "نتيجة واحدة لـ \"{{query}}\"",
    "resultsCount_two": "نتيجتان لـ \"{{query}}\"",
    "resultsCount_few": "{{count}} نتائج لـ \"{{query}}\"",
    "resultsCount_many": "{{count}} نتيجة لـ \"{{query}}\"",
    "resultsCount_other": "{{count}} نتيجة لـ \"{{query}}\"",
    "noResults": "لا توجد نتائج لـ \"{{query}}\""
  }
}
